// extracted by mini-css-extract-plugin
export default {"hidden":"root_chat-app-module__hidden___aNTxB"};